@if (isVisible) {
  <div class="sign-out" class="sign-out-overlay"></div>
}
@if (isVisible) {
  <div class="sign-out-dialog">
    <div class="sign-out-content" [innerHTML]="translateService.instant('main.labels.logout_confirmation')">
    </div>
    <div style="height: 30%;">
      <table style="width: 100%;height:100%">
        <tr>
          <td class="sign-out-cancel" (click)="hideModal()">
            {{translateService.instant("main.labels.Cancel")}}
          </td>
          <td class="sign-out-yes" (click)="signOut()">
            {{translateService.instant("main.labels.Yes")}}
          </td>
        </tr>
      </table>
    </div>
  </div>
}
